// extracted by mini-css-extract-plugin
export var cardIcon = "_4a-4";
export var checkboxCard = "_4a-0";
export var checkboxCardSelected = "_4a-1";
export var disabled = "_4a-2";
export var outerBorder = "_4a-3";
export var spacerMedium = "_4a-7";
export var spacerSmall = "_4a-6";
export var spacerXsmall = "_4a-5";